module.exports = __webpack_public_path__ + "img/faseh.b99c5258.svg";